import React from 'react'
export default class ReservationBuilderLoadingSpinner extends React.Component {

  constructor(props) {
    super(props);
  };

  componentDidMount() {
    this.fadeInOutOverlay(this.props.show);
  };

  componentDidUpdate(prevProps) {
    this.fadeInOutOverlay(this.props.show);
  };

  render() {
    return (
      <div className="loadingOverlay" id="spinner-overlay" style={{backgroundColor: 'transparent'}}>
        <div className="spinner"></div>
      </div>
    );
  };

  fadeInOutOverlay(show) {
    if (show) {
      $(`#spinner-overlay`).show();
    } else {
      $(`#spinner-overlay`).hide();
    };
  };

};